import styled from 'styled-components';
import COLORS from 'shared/constants/colors';

const Container = styled.div`
  padding: 0 15px;
`;
const Wrapper = styled.div`
  margin-right: auto;
  margin-left: auto;
  max-width: 1200px;
  width: 100%;
`;
const IntegrationSection = styled.div`
  padding: 32px 0;
  border-bottom: 1px solid #ccc;
  margin-bottom: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  justify-items: center;
  flex-direction: column;
  @media (min-width: 1024px) {
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-direction: row;
  }
  h4 {
    color: #000;
    text-transform: uppercase;
    margin: 0;
    font-size: 20px;
  }
  img {
    margin: 16px 0;
  }
`;
const KeyFeatures = styled.div`
  padding: 32px 0;
  display: grid;
  margin-bottom: 17px;
  color: ${COLORS.BLACK};

  h2 {
    text-align: center;
    font-size: 28px;
    line-height: 42px;
    text-transform: uppercase;
    margin-bottom: 17px;
    margin-top: 0;
    @media (max-width: 1200px) {
      font-size: calc(1.3rem + 0.6vw);
    }
  }
  > div {
    margin-left: 0;
    list-style: none;
    display: grid;
    justify-content: space-around;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    grid-gap: 30px;
    p {
      display: flex;
      align-items: center;
      font-size: 19px;
      justify-content: center;
      margin: 19px 0;
      @media (max-width: 768.9px) {
        margin-top: 0;
        margin-bottom: 7.5px;
      }
    }
    svg {
      margin-right: 5px;
      color: #009144;
    }
  }
`;

export { Container, Wrapper, IntegrationSection, KeyFeatures };
